import {debounce} from "./utils";
import {POP, NEW, SELL} from "./const";

import HomeSwiper from "../../view/home/childComps/HomeSwiper";
import Scroll from "./scroll/Scroll";
import NavBar from "./navbar/NavBar";

export const goodsitemImageLoadRefresh={
    data(){
        return{
            newRefresh:null,
            GoodsListItemImgListener:null,
        }
    },
    mounted() {
        // 封装返回的防抖动函数
        this.newRefresh= debounce(this.$refs.scroll.refresh,100);
        this.GoodsListItemImgListener= ()=>{
            this.newRefresh();
        };
        this.$bus.$on('imgLoad',this.GoodsListItemImgListener)
    },
    // destroyed() {
    //     //取消对全局事件对该组件this.GoodsListItemImgListener的监听
    //     this.$bus.$off(this.GoodsListItemImgListener);
    // },
}
export const cartImageLoadRefresh={
    data(){
        return{
            newRefresh:null,
            cartListItemImgListener:null,
        }
    },
    mounted() {
        // 封装返回的防抖动函数
        this.newRefresh= debounce(this.$refs.scroll.refresh,100);
        this.cartListItemImgListener= ()=>{
            this.newRefresh();
        };
        this.$bus.$on('cartImgLoad',this.cartListItemImgListener)
    },
    // destroyed() {
    //     //取消对全局事件对该组件this.GoodsListItemImgListener的监听
    //     this.$bus.$off(this.GoodsListItemImgListener);
    // },
}
export const tabControlMixin = {

    data: function () {
        return {
            tabOffsetTop: 0,
            isTabFixed: false,
            currentType: POP,
            newPosition:null,
        }
    },
    mounted() {
        // this.newPosition= debounce(()=>{this.$refs.tabControl.$el.offsetTop},100);
    },
    methods: {
        tabClick(index) {
            switch (index) {
                case 0:
                    this.currentType = POP
                    break
                case 1:
                    this.currentType = NEW
                    break
                case 2:
                    this.currentType = SELL
                    break
            }
                this.$refs.tabControl.currentIndex=index;
                this.$refs.topTabControl.currentIndex=index;
            // console.log(this.currentType);
        },
        TabControlPosition(){
            // this.newPosition()

            // this.$bus.$on('imgLoad',this.GoodsListItemImgListener)
            this.tabOffsetTop=this.$refs.tabControl.$el.offsetTop;
        },
        showTabControl(){
            this.isTabFixed=this.position.y<(-this.tabOffsetTop);
        },
        // contentScroll(position){
            // this.isShowBackTop= (-position.y) >1000;
        //     this.isTabFixed=position.y<(-this.tabOffsetTop);
        // },
        // swiperImageLoad(){
        //     this.tabOffsetTop=this.$refs.tabControl.$el.offsetTop;
            // console.log(this.$refs.tabControl.$el.offsetTop);
        // },
    }

}
